<template>
  <div class="login-page p-4 d-flex justify-content-center">
    <div class="card shadow" style="border-radius: 0.75rem">
      <div
        class="card-body row shadow login-card-body"
        style="border-radius: 0.75rem"
      >
        <form
          @submit.prevent="login()"
          class="d-flex col-12 col-md-6 flex-column justify-content-center"
        >
          <div class="py-3">
            <h3 class="font-weight-bold text-dark">Login</h3>
            <p class="mb-0" v-if="errorMessage">
              <small class="text-danger">
                {{ errorMessage }}
              </small>
            </p>
          </div>
          <div class="mb-3">
            <div class="mb-3">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'border-danger': $v.username.$error }"
                  placeholder="Username"
                  v-model="username"
                />
                <div class="input-group-append">
                  <div
                    class="input-group-text"
                    :class="{ 'border-danger': $v.username.$error }"
                  >
                    <span class="fas fa-user"></span>
                  </div>
                </div>
              </div>
              <div class="text-danger" v-if="$v.username.$error">
                <small>Username Required</small>
              </div>
            </div>
            <div class="mb-3">
              <div class="input-group">
                <input
                  :type="show.password ? 'text' : 'password'"
                  class="form-control"
                  :class="{ 'border-danger': $v.password.$error }"
                  placeholder="Password"
                  v-model="password"
                />
                <div class="input-group-append">
                  <div
                    class="input-group-text"
                    :class="{ 'border-danger': $v.password.$error }"
                    @click="showPassword()"
                  >
                    <span
                      class="fas"
                      :class="{
                        'fa-eye': !show.password,
                        'fa-eye-slash': show.password,
                      }"
                    ></span>
                  </div>
                </div>
              </div>
              <div class="text-danger" v-if="$v.password.$error">
                <small>Password Required</small>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <input type="checkbox" id="remember" v-model="remember_me" />
              <label for="remember" class="mb-0 ml-2" style="cursor: pointer">
                Remember Me
              </label>
            </div>
          </div>

          <div class="row">
            <div class="col-12 card-button-container">
              <button
                type="submit"
                class="btn btn-danger btn-block rounded-pill"
                :disabled="submitStatus === 'PENDING'"
              >
                Login
              </button>
              <hr class="w-100 my-2" />
              <!-- <router-link
                :to="{ name: 'Register' }"
                class="btn btn-outline-danger btn-block rounded-pill"
              >
                Register
              </router-link> -->
              <router-link
                :to="{ name: 'ForgetPassword' }"
                class="text-secondary mt-3"
              >
                <small>Forgot password?</small>
              </router-link>
            </div>
          </div>
        </form>
        <div class="d-flex col-12 col-md-6 align-items-center p-3 p-lg-5">
          <img src="@/assets/svg/login.svg" alt="login vector" class="w-100" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      username: "",
      password: "",
      remember_me: false,
      submitStatus: null,
      errorMessage: null,
      show: {
        password: false,
      },
    };
  },
  created() {
    document.title = "Login - Manager Cabang";
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    showPassword() {
      this.show.password = !this.show.password;
    },
    async login() {
        this.errorMessage = "";

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        await this.$store
          .dispatch("login", {
            username: this.username,
            password: this.password,
            remember_me: this.remember_me,
          })
          .then(() => {
            this.submitStatus = "OK";
            this.errorMessage = "";
            this.$router.push({ name: "Dashboard" }).catch(() => {});
          })
          .catch((error) => {
            this.submitStatus = "ERROR";
            this.errorMessage = error.response.data.message;
          });
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  background-image: url("~@/assets/svg/wave.svg");
  background-size: cover;
  background-position: center;
}

.card-body {
  border-radius: 0.75rem !important;
  width: 100%;
  flex-flow: wrap-reverse;
  grid-template-columns: 50% 50%;
}
.card-button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (min-width: 319px) {
}

@media (min-width: 374px) {
}

@media (min-width: 424px) {
  .name-profile h1 {
    font-size: 2.5rem;
  }
}

@media (min-width: 767px) {
  .card-body {
  width: 700px;
  }
}

@media (min-width: 1023px) {
  .card-body {
  width: 800px;
  }
}

@media (min-width: 1439px) {
}

@media (min-width: 2000px) {
}
</style>